import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '@/store';
import { CategoriesState, CATEGORIES_SLICE_NAME } from './models';

export const categoriesSelector = (state: RootState): CategoriesState => state[CATEGORIES_SLICE_NAME];

export const selectCategories = createSelector(categoriesSelector, (state: CategoriesState) => state.categories);
export const selectPopularCategories = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.popularCategories,
);

export const selectCategoryDetails = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.categoryDetails,
);

export const selectFilters = createSelector(categoriesSelector, (state: CategoriesState) => state.filters);

export const selectFiltersQuery = createSelector(categoriesSelector, (state: CategoriesState) => state.filtersQuery);

export const selectCategoriesIsLoading = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.isLoadingCategories,
);

export const selectCategoryDetailsIsLoading = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.isLoadingCategoryDetails,
);

export const selectFiltersValuesQuery = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.filtersValuesQuery,
);

export const selectCategoryStats = createSelector(categoriesSelector, (state: CategoriesState) => state.categoryStats);

export const selectCategoryStatsQuery = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.categoryStatsQuery,
);

export const selectCategoryStatsIsLoading = createSelector(
  categoriesSelector,
  (state: CategoriesState) => state.isLoading,
);
